import React from 'react';
import {

  PlayersInner,
  PlayerInner,
  PlayerPair,
  ActionButton

} from './final.js';

class RandomRelationsPlayers extends React.Component {
  LABELS = { MEN: "Мужчины", WOMEN: "Девушки" };
  MESSAGES = { MEN: "Из мужчин пока никто не подтвердил участие", WOMEN: "Из девушек пока никто не подтвердил участие" };

  label = () => {
    if (this.props.game.isMenLimited) return this.LABELS.MEN;
    if (this.props.game.isWomenLimited) return this.LABELS.WOMEN;
  }

  message = () => {
    if (this.props.game.isMenLimited) return this.MESSAGES.MEN;
    if (this.props.game.isWomenLimited) return this.MESSAGES.WOMEN;
  }

  players = () => {
    if (this.props.game.isMenLimited || this.props.game.isWomenLimited) {
      return (
        <PlayersInner
          label={this.label()}
          message={this.message()}
          players={this.props.game.playersWithPayment}
          totalPlayersNum={this.props.game.totalPlayersWithPaymentNum}
          numberOfPlayers={this.props.game.numberOfPlayers}
          playersCount={true}
          flag={""}
        />
      )
    } else {
      return (
        <React.Fragment>
          <PlayersInner
            key={1}
            label={this.LABELS.WOMEN}
            message={this.MESSAGES.WOMEN}
            players={this.props.game.womanPlayersWithPayment}
            totalPlayersNum={this.props.game.womanPlayersWithPayment.length}
            numberOfPlayers={this.props.game.numberOfPlayers / 2}
            playersCount={true}
            flag={""}
          />
          <PlayersInner
            key={2}
            label={this.LABELS.MEN}
            message={this.MESSAGES.MEN}
            players={this.props.game.manPlayersWithPayment}
            totalPlayersNum={this.props.game.manPlayersWithPayment.length}
            numberOfPlayers={this.props.game.numberOfPlayers / 2}
            playersCount={true}
            flag={""}
          />
        </React.Fragment>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default RandomRelationsPlayers;
